<template>
  <hm-content title="核销中心">
    <div>
      <el-input
        clearable
        v-model.trim="authCode"
        placeholder="输入核销码"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="writeOff">核销</el-button>
    </div>
    <div class="title">核销记录</div>
    <el-table
      stripe
      border
      :data="chargeLists"
      style="width: 100%"
      size="small"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="updateTime"
        label="核销时间"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="updateName"
        label="核销操作人"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="authCode"
        label="核销码"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actName"
        label="所属活动"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actSite"
        label="所属地点"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actRound"
        label="所属场次"
      ></el-table-column>
    </el-table>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    return {
      authCode: ""
    };
  },
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  computed: mapGetters(["chargeLists"]),
  methods: {
    queryList() {
      this.setParamsCookie();
      return this.$store.dispatch("chargeList", {
        authCode: this.authCode
      });
    },
    setParamsCookie() {
      let searchCondition = {
        authCode: this.authCode
      };
      setCookie({
        key: "writeOffCenterParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "writeOffCenterParams", type: "session" });
      if (prams) {
        this.authCode = prams.authCode;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    writeOff() {
      this.$store
        .dispatch("chargeOffFromCode", {
          authCode: this.authCode
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  margin: 20px 0;
  font-size: 14px;
  &::before {
    content: "";
    width: 3px;
    height: 12px;
    background: #e60065;
    display: inline-block;
    margin-right: 10px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
